// extracted by mini-css-extract-plugin
module.exports = {"section":"OrganisationWrapped_section__1j5Yr","inputBox":"OrganisationWrapped_inputBox__3X9za","errorMessage":"OrganisationWrapped_errorMessage__1ALq6"};